import { useEffect } from "react";
import ListDataProject from "./ListDataProject";
import { useDispatch } from "react-redux";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function Project() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadCrumb([{ label: "PROJECT", link: "" }]));
  }, []);

  return (
    <ListDataProject
      titles={[
        "Sl No.", "Project Id", "Quotation Id", "Project Name",
        "Quotation Type", "VISA Provider", "Client", "Action",
      ]}
    />
  );
}
